export const getFileUrl = (file: File) => URL.createObjectURL(file);